import MaterialUiCheckBox from '@material-ui/core/Checkbox';
import type { FormControlLabelProps } from '@material-ui/core/FormControlLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDisplayLabel } from '@ps/web-shared-components';
import type { LabelProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import type { FieldMetaState } from 'react-final-form';

import CheckboxCheckedIcon from '@swf/core/assets/icons/checkbox-selected.svg';
import CheckboxOutlineIcon from '@swf/core/assets/icons/checkbox.svg';
import useTrackers from '@swf/core/hooks/useTrackers';
import useTrackingLabel from '@swf/core/hooks/useTrackingLabel';

import {
  disabled as checkBoxDisabled,
  label as checkBoxLabel,
  checkbox,
  checkboxError,
  labelError,
  root
} from './Checkbox.scss';

type Props = {
  className?: string;
  meta?: FieldMetaState<string>;
  compoundLabel?: React.ReactNode;
  disabled?: boolean;
  label: LabelProp;
} & Pick<FormControlLabelProps, 'name' | 'checked' | 'onChange' | 'value'>;

const Checkbox: React.FunctionComponent<Props> = ({
  meta,
  className,
  compoundLabel,
  label,
  disabled,
  onChange,
  ...rest
}) => {
  const { inputFilled } = useTrackers();
  const error = meta?.touched && meta?.invalid;
  const displayLabel = useDisplayLabel(label);
  const fieldName = useTrackingLabel(label);

  return (
    <FormControlLabel
      {...rest}
      label={displayLabel}
      onChange={(event, checked) => {
        onChange?.(event, checked);
        inputFilled({ fieldName, fieldType: 'checkbox', boolInput: checked });
      }}
      control={
        <MaterialUiCheckBox
          icon={<CheckboxOutlineIcon />}
          checkedIcon={
            <CheckboxCheckedIcon
              className={classNames({
                [checkBoxDisabled]: disabled
              })}
            />
          }
          classes={{
            root: classNames(checkbox, { [checkboxError]: error })
          }}
          disabled={disabled}
        />
      }
      classes={{
        label: classNames(className, checkBoxLabel, {
          [labelError]: error
        }),
        root
      }}
    />
  );
};

export default Checkbox;
